const data = [
  {
    name: "Building Startups & Raising Investment in Pakistan with Bfreeze",
    tags: ["Entrepreneurship", "DeepTech", "Startups", "Women In STEM"],
    link: "https://www.facebook.com/2325449904140726/videos/515361172829606",
  },
  {
    name: "Where Were We",
    tags: ["Biotechnology", "Partnerships"],
    link: "https://www.facebook.com/2325449904140726/videos/3631833226944431",
  },
  {
    name: "Lala Rukh | Science Fuse | Science Education in Pakistan",
    tags: [
      "Science Education",
      "Science Communication",
      "Kids Education",
      "Women In STEM",
    ],
    link: "https://www.facebook.com/sciencefuse/videos/777584369753154/",
  },
  {
    name: "Astronomy, Science & Society with Dr Salman Hameed",
    tags: ["Science & Society", "Islam & Science", "Astronomy"],
    link: "https://www.facebook.com/2325449904140726/videos/2645849092396362",
  },
  {
    name: "STEM Education in Pakistan with Abdul Rauf, founder of Pakistan Science Club",
    tags: ["STEM Education", "Science Education", "Science Accessibility"],
    link: "https://www.facebook.com/2325449904140726/videos/795290547939625",
  },
  {
    name: "SDGs, Environment and Pakistan with Ali Hasanain Syed",
    tags: ["Sustainability", "Climate Change", "Science & Politics"],
    link: "https://www.facebook.com/2325449904140726/videos/1449405878602791",
  },
  {
    name: "Climate Change awareness and understanding in Pakistan with Sharmeen Tariq",
    tags: ["Climate Change"],
    link: "https://www.facebook.com/2325449904140726/videos/261272721756423",
  },
  {
    name: "Building an Astronomy Community & Promoting STEM Education in Pakistan with Roshaan Bukhari",
    tags: [
      "Astronomy",
      "Science Education",
      "Community Development",
      "Science Advocacy",
    ],
    link: "https://www.facebook.com/2325449904140726/videos/581599972461122",
  },
  {
    name: "Interview with Muhammad Shaheer Niazi on life after Honeycomb",
    tags: ["Undergrad Admissions", "Science Popularization", "Archaeology"],
    link: "https://www.facebook.com/2325449904140726/videos/702944373867570",
  },
  {
    name: "Space Settlement & Astrobiology with Yumna Majeed (Founder Exploration)",
    tags: [
      "Astronomy",
      "Science Education",
      "Science Popularization",
      "Women in STEM",
      "Astrobiology",
    ],
    link: "https://www.facebook.com/2325449904140726/videos/522743398420426",
  },
  {
    name: "Promoting Astronomy Education in Pakistan with Yumna Majeed (Founder Exploration)",
    tags: [
      "Astronomy",
      "Science Education",
      "Science Popularization",
      "Women in STEM",
    ],
    link: "https://www.facebook.com/2325449904140726/videos/928694017584233",
  },
  {
    name: "Synthetic Biology and Gene Drives with Moeez Khan",
    tags: ["Synthetic Biology", "Science Communication"],
    link: "https://www.facebook.com/hassnain.qasim.1/videos/1654000374741231",
  },
  {
    name: "Covid 19 Prevention, Treatment and Awareness with Dr Fyezah Jehan (Aga Khan University) and Dr Ammad Faheem (NUMS)",
    tags: ["Covid 19"],
    link: "https://www.youtube.com/embed/zvtQl0gfPGQ",
  },
];

export default data;
